"use client";

import { safeWindow } from "@/utils/safe-window";
import { useCallback } from "react";

export const SESSION_STORAGE_KEY = {
  // 未ログイン状態でログインが必要なページにアクセスしたときに、ログイン後にリダイレクトするURL
  comebackUrl: "comebackUrl",
} as const;

type SessionStorageKey = keyof typeof SESSION_STORAGE_KEY;

export function useSessionStorage() {
  const setItem = useCallback((key: SessionStorageKey, value: string) => {
    safeWindow?.sessionStorage.setItem(key, value);
  }, []);

  const getItem = useCallback((key: SessionStorageKey) => {
    return safeWindow?.sessionStorage.getItem(key) ?? undefined;
  }, []);

  const removeItem = useCallback((key: SessionStorageKey) => {
    safeWindow?.sessionStorage.removeItem(key);
  }, []);

  const clearAll = useCallback(() => {
    Object.values(SESSION_STORAGE_KEY).forEach((key) => {
      safeWindow?.sessionStorage.removeItem(key);
    });
  }, []);

  return {
    setItem,
    getItem,
    removeItem,
    clearAll,
  };
}
